module.exports = __webpack_public_path__ + "static/img/logo-m.5728c20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-m.png
// module id = 378
// module chunks = 140